import { Card, Row, Col, Image, Spin, Modal, message, Button, Table, Alert, Steps, Typography } from "antd";
import logo from "../../assets/images/NewLogoCW.svg";
import red from "../../assets/images/red.svg";
import green from "../../assets/images/green.svg";
import posImg from "../../assets/images/posImg.svg";
import db, { isDbBridgeAvailable } from "../../database";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";
import { timeStamp } from "../../utils/timestamp";
import { useEffect, useState, useRef } from "react";
import { LoadingOutlined, MedicineBoxOutlined, CheckCircleOutlined, CloseCircleOutlined, SyncOutlined } from "@ant-design/icons";
import { getOAuthHeaders } from "../../constants/oAuthValidation";
import { useHistory } from "react-router-dom";
import { getTills, posConfigService, syncTillData, upsertPOSActivity } from "../../services";
import { useTranslation } from "react-i18next";
import { getMultilingualText } from "../../utils/getMultilingualText";
import laptop3 from "../../assets/images/laptop3.svg";
import Scrollbars from "react-custom-scrollbars";
import { getStoreOps, upsertStoreOps, tillRegistration } from "../../services";
import SyncSide from "../../assets/images/sideFullSync.svg";
import messages from "../../errors/messages.en-IN.json";
import PostCloseSalesModal from "./PostCloseSalesModal";
import useAuthStore from "../../stores/useAuthStore";
import usePOSConfigStore from "../../stores/usePOSConfigStore";
import useCartStore from "../../stores/useCartStore";
import useSessionStore from "../../stores/useSessionStore";
import useTransactionStore from "../../stores/useTransactionStore";
import useRestaurantStore from "../../stores/useRestaurantStore";
import useReferenceStore from "../../stores/useReferenceStore";
import { trace } from "../../utils/debugTrace";
import { getLocalMaxSequence, resolveInitialDocumentSequence } from "../../utils/documentSequenceUtils";
import { logSequenceEvent } from "../../utils/sequenceAudit";
import { getTillMode, getTillModeRoute, pickDefaultRoute, parseTillAccess, sessionOwnerMatchesCurrentUser, TILL_MODES } from "../../constants/accessControl";
import "./TillScreens.css";

const Till = () => {
  const { t } = useTranslation();
  const multilingual = process.env.REACT_APP_MULTILINGUAL === "true" && localStorage.getItem("selectedLanguage") !== "English";
  const redirectUrl = process.env.REACT_APP_redirectURL;
  const [runEffect, setRunEffect] = useState(true);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [tills, setTills] = useState();
  const [tillLoadError, setTillLoadError] = useState(null);
  const [tillValue, setTillValue] = useState(() => {
    // Clear stale tillValue on entry so a previous selection doesn't persist
    const stored = useAuthStore.getState().tillValue;
    return stored || {};
  });
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorProducts, setErrorProducts] = useState([]);
  const [postCloseModalVisible, setPostCloseModalVisible] = useState(false);
  const [postCloseData, setPostCloseData] = useState({
    storeClosedDate: "",
    newBusinessDate: "",
    closedTime: "",
    tillId: "",
    cashierName: "",
  });
  const retryCountRef = useRef(0);
  const MAX_RETRIES = 3;
  const REGISTRATION_STEPS = ["Syncing Till Data", "Loading POS Config", "Checking Store", "Registering Till", "Navigating"];
  const [registrationStep, setRegistrationStep] = useState(-1);
  const [registrationError, setRegistrationError] = useState(null);
  const [lastRegistrationArgs, setLastRegistrationArgs] = useState(null);
  const [resumeSetupVisible, setResumeSetupVisible] = useState(false);
  const islocked = useSessionStore.getState().locked;
  let email = "";
  let Enterprise = "";
  let username;
  let cleanToken;
  const authHeaders = getOAuthHeaders();
  if (authHeaders && authHeaders.access_token && (authHeaders.email || authHeaders.username)) {
    email = authHeaders.email;
    Enterprise = authHeaders.Enterprise;
    cleanToken = authHeaders.access_token;
    username = authHeaders.username;
  } else {
    console.warn("[AUTH-DIAG] Till → redirecting to /sign-in (no valid auth)");
    history.push("/sign-in");
  }

  const handleStoreOpsService = async (bunitId) => {
    const posConfig = usePOSConfigStore.getState().posConfig;
    const tillData = useAuthStore.getState().tillData;
    const dayEndPreferences = JSON.parse(tillData?.dayEndPreferences || "[]");
    trace("Till", "handleStoreOpsService", {
      bunitId,
      disableOffline: posConfig?.disableOfflineBilling,
      tillAccessType: Array.isArray(tillData?.tillAccess) ? "ARRAY" : typeof tillData?.tillAccess,
      hasCsBunit: !!tillData?.tillAccess?.csBunit,
    });
    if (posConfig?.disableOfflineBilling === "Y" && dayEndPreferences[0]?.postCloseSalesDate === "NXT") {
      const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();
      trace("Till", "storeOps(NXT) openEvents", { count: tillEvents.length, date: tillEvents[0]?.openingTime?.split(" ")[0] });
      if (tillEvents.length > 0) {
        const currentDate = dayjs().format("YYYY-MM-DD");
        const tillEventDate = tillEvents[0]?.openingTime?.split(" ")[0];
        if (currentDate === tillEventDate) {
          return await getStoreOps(bunitId);
        } else if (posConfig?.enableAutoStoreClose !== "Y") {
          trace("Till", "day change (NXT) but auto close disabled — continuing billing", { currentDate, tillEventDate });
          return await getStoreOps(bunitId);
        } else {
          trace("Till", "day change detected (NXT) → /close-till", { currentDate, tillEventDate });
          const activeTillSession = useSessionStore.getState().tillSession;
          if (!activeTillSession) {
            trace("Till", "day change (NXT): no tillSession — orphaned open events, closing silently");
            await db.tillEvents.where("tillStatus").equals("open").modify({ tillStatus: "closed", isSynced: 1 });
            return await getStoreOps(bunitId);
          }
          setLoading(false);
          history.push("/close-till");
          return { redirected: true };
        }
      } else {
        const response = await getStoreOps(bunitId);
        if (response?.status === 200) {
          const storeOpsData = response?.data?.data?.getStoreOps;
          if (storeOpsData?.status === "OP") {
            return response;
          } else if (storeOpsData?.status === "CL") {
            const tillData = useAuthStore.getState().tillData;
            const tillValue = useAuthStore.getState().tillValue;

            // Calculate dates
            const closedDate = dayjs(storeOpsData?.businessDate || new Date()).format("DD/MM/YYYY");
            const nextBusinessDate = dayjs(storeOpsData?.businessDate || new Date())
              .add(1, "days")
              .format("DD/MM/YYYY");
            const closedTime = storeOpsData?.closedTime || "8:00 PM";

            setPostCloseData({
              storeClosedDate: closedDate,
              newBusinessDate: nextBusinessDate,
              closedTime: closedTime,
              tillId: tillValue?.name || tillData?.tillAccess?.cwrTill?.till || "N/A",
              cashierName: username || "N/A",
            });
            setPostCloseModalVisible(true);
            setLoading(false);
            return { redirected: true };
          } else if (!storeOpsData) {
            return response;
          }
        }
      }
    } else {
      const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();
      trace("Till", "storeOps(normal) openEvents", { count: tillEvents.length, date: tillEvents[0]?.openingTime?.split(" ")[0] });
      if (tillEvents.length > 0) {
        const currentDate = dayjs().format("YYYY-MM-DD");
        const tillEventDate = tillEvents[0]?.openingTime?.split(" ")[0];
        if (currentDate === tillEventDate) {
          return await getStoreOps(bunitId);
        } else if (posConfig?.enableAutoStoreClose !== "Y") {
          trace("Till", "day change but auto close disabled — continuing billing", { currentDate, tillEventDate });
          return await getStoreOps(bunitId);
        } else {
          trace("Till", "day change detected → /close-till", { currentDate, tillEventDate });
          const activeTillSession = useSessionStore.getState().tillSession;
          if (!activeTillSession) {
            trace("Till", "day change: no tillSession — orphaned open events, closing silently");
            await db.tillEvents.where("tillStatus").equals("open").modify({ tillStatus: "closed", isSynced: 1 });
            return await getStoreOps(bunitId);
          }
          setLoading(false);
          history.push("/close-till");
          return { redirected: true };
        }
      } else {
        return await getStoreOps(bunitId);
      }
    }
  };

  // Add handlers for the modal buttons
  const handlePostCloseContinue = async () => {
    setPostCloseModalVisible(false);
    setLoading(true);

    try {
      const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();

      if (tillEvents.length > 0) {
        const tillSessionId = tillEvents[0]?.tillSessionId; // 🔹 rename event → currentEvent

        await db.ordersData
          .where("tillSessionId")
          .equals(tillSessionId)
          .modify((order) => {
            order.tillStatus = "closed";
          });

        await db.paymentsData
          .where("tillSessionId")
          .equals(tillSessionId)
          .modify((payment) => {
            payment.tillStatus = "closed";
          });

        await db.tillEvents
          .where("tillSessionId")
          .equals(tillSessionId)
          .modify((tillEvent) => {
            tillEvent.tillStatus = "closed";
            tillEvent.isSynced = 1;
            tillEvent.user = useAuthStore.getState().userData?.user;
          });
      }

      const userData = useAuthStore.getState().userData || {};
      const userid = userData?.user_id;
      // Use the date already computed from server response (shown in modal), not dayjs().add(1, "day")
      const nextBusinessDate = dayjs(postCloseData.newBusinessDate, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm:ss");
      const response = await getStoreOps(JSON.parse(localStorage.getItem("tillValue"))?.cSBunitID, nextBusinessDate);
      if (response?.status === 200) {
        const storeOpsData = response?.data?.data?.getStoreOps;
        if (storeOpsData?.status === "OP") {
          useSessionStore.getState().setNextBusinessDate(nextBusinessDate);
          setTillValue({});
          history.push("/login");
        } else if (storeOpsData?.status === "CL" || storeOpsData === null) {
          const resStoreOps = await upsertStoreOps(JSON.parse(localStorage.getItem("tillValue"))?.cSBunitID, userid, nextBusinessDate);
          const upsertData = resStoreOps?.data?.data?.upsertStoreOps;

          if (upsertData?.status === "200") {
            useSessionStore.getState().setNextBusinessDate(nextBusinessDate);
            setTillValue({});
            history.push("/login");
          } else {
            message.error(upsertData?.message);
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
        message.error("Could not reach the server. Please check your connection and try again.");
      }
    } catch (error) {
      console.error("Error in handlePostCloseContinue:", error);
      setLoading(false);
      message.error("Could not reach the server. Please check your connection and try again.");
    }
  };

  const handlePostCloseCancel = () => {
    setPostCloseModalVisible(false);
    // Logout logic
    onUserModal();
  };

  const parseRemarksProducts = (remarks) => {
    try {
      const match = remarks.match(/Result:\s*(\[.*\])/);
      if (match && match[1]) {
        let arrStr = match[1];

        // ✅ Quote keys (m_product_id → "m_product_id")
        arrStr = arrStr.replace(/(\w+):/g, '"$1":');

        // ✅ Quote string values that are not already quoted/null
        arrStr = arrStr.replace(/:"([^",\]\}]*)"(?![,\]\}])/g, (m, p1) => {
          // already quoted string, leave it
          return m;
        });
        arrStr = arrStr.replace(/:"?([^",\]\}]+)"?(?=[,\]\}])/g, (m, p1) => {
          if (p1 === "null") return ":null"; // keep null
          return `:"${p1.trim()}"`;
        });

        return JSON.parse(arrStr);
      }
    } catch (err) {
      console.error("Error parsing remarks:", err, remarks);
    }
    return [];
  };

  useEffect(() => {
    const runAsync = async () => {
    // Hydrate POS module stores now that we're entering the POS module.
    // These are kept out of App.js boot so non-POS modules (Inventory,
    // PurchaseOrder, etc.) don't pay the cost of loading POS state.
    await Promise.all([
      usePOSConfigStore.persist.rehydrate(),
      useCartStore.persist.rehydrate(),
      useSessionStore.persist.rehydrate(),
      useTransactionStore.persist.rehydrate(),
      useRestaurantStore.persist.rehydrate(),
      useReferenceStore.persist.rehydrate(),
    ]);

    // FIX 4: Recovery for stale tillSession on app restart
    // If a tillSession exists with "open" status but the till was never properly
    // opened in this session (no matching tillEvent in DB), clear the stale session
    // so the user can proceed with till selection without being blocked.
    const existingTillSession = useSessionStore.getState().tillSession;
    trace("Till", "stale check start", {
      hasTillSession: !!existingTillSession,
      tillStatus: existingTillSession?.tillStatus,
      tillSessionId: existingTillSession?.tillSessionId?.slice(0, 8),
    });
    if (existingTillSession && existingTillSession.tillStatus === "open") {
      try {
        const matchingEvents = await db.tillEvents
          .where("tillSessionId")
          .equals(existingTillSession.tillSessionId)
          .toArray();
        trace("Till", "stale check DB result", { matchCount: matchingEvents?.length });
        if ((!matchingEvents || matchingEvents.length === 0) && !isDbBridgeAvailable()) {
          // BUG-2081: empty result may mean the Electron IPC bridge is
          // momentarily unreachable, not that the session is actually stale —
          // preserve it the same way a real DB error is already preserved
          // below, instead of clearing a possibly-still-valid session.
          trace("Till", "stale check inconclusive — DB bridge unavailable, preserving session");
        } else if (!matchingEvents || matchingEvents.length === 0) {
          // Stale session from a previous run — clear it so user can proceed
          trace("Till", "stale → clearing tillSession");
          console.warn("Clearing stale tillSession (no matching tillEvent in DB):", existingTillSession.tillSessionId);
          useSessionStore.getState().setTillSession(null);
        }
      } catch (err) {
        console.error("Error checking tillSession recovery:", err);
        trace("Till", "stale check DB ERROR — preserving session", { error: err?.message });
        // On DB error, preserve the session — it may still be valid.
        // handleStoreOpsService will detect a day-change if there is one.
      }
    }

    // BUG-1564: If till session is valid and from today, skip till selection
    // and go directly to /pos. This handles browser refresh in CW Browser where
    // the URL resets to / → /till instead of staying at /pos.
    // BUG-1994: same fast-forward gap as App.js's AuthRedirect — must not
    // resume a session left open by a different, previously-logged-in user.
    // A mismatch here just falls through to the normal Till.js flow below,
    // which fetches tills for the *current* user and rejects them if they
    // have no access, instead of silently reusing the stale tillData.
    const activeSession = useSessionStore.getState().tillSession;
    const rehydratedTillData = useAuthStore.getState().tillData;
    const rehydratedPosConfig = usePOSConfigStore.getState().posConfig;
    const tillDataOwner = useAuthStore.getState().tillDataOwner;
    const currentIdentity = username || email || null;
    const identityMatches = sessionOwnerMatchesCurrentUser(tillDataOwner, currentIdentity);
    if (activeSession?.tillStatus === "open" && rehydratedTillData?.tillAccess && rehydratedPosConfig && identityMatches) {
      try {
        const sessionEvents = await db.tillEvents
          .where("tillSessionId")
          .equals(activeSession.tillSessionId)
          .toArray();
        const openEvent = sessionEvents.find((e) => e.tillStatus === "open");
        if (openEvent) {
          const tillDate = openEvent.openingTime?.split(" ")[0];
          // BUG-1902: when Enable Auto Close is off (posConfig.enableAutoStoreClose !== "Y"),
          // billing continues across midnight on the same open till — a date rollover alone
          // must not force /close-till, only an actual server-side day change should.
          if (tillDate === dayjs().format("YYYY-MM-DD") || rehydratedPosConfig?.enableAutoStoreClose !== "Y") {
            // TSK-2997: resolve from the till's own mode instead of a hardcoded /pos,
            // so estimate/production tills don't take an extra hop through the gate.
            const fastForwardTo = pickDefaultRoute({
              posConfig: rehydratedPosConfig,
              tillaccess: parseTillAccess(rehydratedTillData),
            });
            trace("Till", "BUG-1564: active session usable, fast-forwarding", { to: fastForwardTo, tillDate, enableAutoStoreClose: rehydratedPosConfig?.enableAutoStoreClose });
            history.push(fastForwardTo);
            return;
          }
        }
      } catch (err) {
        trace("Till", "BUG-1564: session check failed, continuing normal flow", { error: err?.message });
      }
    }

    const tillRegistrations = await db.tillRegistrations.toArray();
    const lastUpdatedTime = useSessionStore.getState().lastUpdatedTime;
    // PRD tills never run processSync (Login.js syncs docTypes/UOM instead), so
    // lastUpdatedTime never gets set for them — this check would otherwise fire
    // on every login once they register.
    if (tillRegistrations.length > 0 && !lastUpdatedTime && usePOSConfigStore.getState().posType !== "PRD") {
      const productCount = await db.products.count();
      if (productCount === 0) {
        setResumeSetupVisible(true);
      }
    }
    const posType = usePOSConfigStore.getState().posType;
    const posConfig = usePOSConfigStore.getState().posConfig;
    if (runEffect) {
      setRunEffect(!runEffect);
      const nameTill = tillValue?.name;
      if (nameTill && (username || email) && cleanToken && tillRegistrations.length > 0) {
        setLoading(true);
        const userData = Enterprise ? username : email;
        const syncSuccess = await syncTillData(userData, authHeaders);
        let tillData = useAuthStore.getState().tillData;
        if (!tillData || !syncSuccess) {
          console.warn("[Till] syncTillData failed or tillData missing after sync — falling back to getTillData()");
          retryCountRef.current += 1;
          setLoading(false);
          setTillLoadError(syncSuccess === false ? "sync_failed" : "no_till_data");
          getTillData();
          return;
        }
        if (tillData) {
          const tillAccessData = tillData.tillAccess;
          if (!tillAccessData || !Array.isArray(tillAccessData) || tillAccessData?.length === 0) {
            console.warn("[Till] tillAccess empty or not an array — falling back to getTillData()");
            retryCountRef.current += 1;
            setLoading(false);
            setTillLoadError("no_till_access");
            getTillData();
            return;
          }
          const tillAccessIndex = (tillAccessData || [])?.findIndex((accessTill) => accessTill.cwrTill.till === nameTill);
          if (tillAccessIndex >= 0 || (tillAccessData && typeof tillAccessData === "object" && !Array.isArray(tillAccessData))) {
            if (islocked) {
              try {
                // New object (not mutated in place) — Zustand/React compare tillData by
                // reference, so reusing the same object here would make this update
                // invisible to any component subscribed via useAuthStore((s) => s.tillData).
                tillData = {
                  ...tillData,
                  tillAccess: tillAccessIndex >= 0 ? tillAccessData[tillAccessIndex] : tillAccessData,
                  time: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                };
                useAuthStore.getState().setUsername(username);
                useAuthStore.getState().setTillData(tillData);
              } catch (err) {
                console.error("Error during unlock till data lookup:", err);
              } finally {
                // Always clear lock state even if till data lookup fails
                useSessionStore.getState().setLocked(false);
              }
              setTillValue({});
              // TSK-2997: a PRD till used to always land on /production here, even when
              // it is an RM-Issue till — mirror Login/index.js and branch on the flags.
              const tillMode = getTillMode(posConfig);
              if (posType === "PRD") {
                history.push(getTillModeRoute(tillMode === TILL_MODES.PRODUCTION_RM_ISSUE ? TILL_MODES.PRODUCTION_RM_ISSUE : TILL_MODES.PRODUCTION));
              } else if (tillMode === TILL_MODES.ESTIMATE) {
                history.push("/estimate");
              } else {
                history.push("/pos");
              }
            } else if (posType === "PRD") {
              setTillValue({});
              history.push(`/login`);
            } else {
              const handleStoreOps = async () => {
                try {
                  // New object (not mutated in place) — see note above; keeps the
                  // reference change visible to Zustand/React subscribers.
                  tillData = {
                    ...tillData,
                    tillAccess: tillAccessIndex >= 0 ? tillAccessData[tillAccessIndex] : tillAccessData,
                    time: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                  };
                  useAuthStore.getState().setTillData(tillData);
                  const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
                  const matchedRep = salesReps.find((rep) => rep.name === username);
                  if (matchedRep) {
                    setTillValue({});
                    history.push(`/login`);
                  } else {
                    const result = await handleStoreOpsService(tillValue?.cSBunitID);
                    if (result?.redirected) return;
                    const storeOpsData = result?.data?.data?.getStoreOps;
                    if (result?.data?.data?.getStoreOps?.status === "ERR") {
                      setLoading(false);
                      const remarks = result?.data?.data?.getStoreOps?.remarks;
                      const products = parseRemarksProducts(remarks);
                      if (products.length > 0) {
                        setErrorProducts(products);
                        setErrorModalVisible(true);
                      } else {
                        message.error(remarks || `${messages.errors.system.unexpected_error}`);
                      }
                      return;
                    } else if (result?.data?.data?.getStoreOps?.status === "WAR") {
                      message.error(result?.data?.data?.getStoreOps?.remarks);
                    }
                    if (!storeOpsData) {
                      const resStoreOps = await upsertStoreOps(tillValue?.cSBunitID, tillData.tillAccess.csUserId);
                      const upsertData = resStoreOps?.data?.data?.upsertStoreOps;
                      if (upsertData?.status === "200") {
                        setTillValue({});
                        history.push(`/login`);
                      } else {
                        message.error(upsertData?.message);
                        setLoading(false);
                      }
                    } else if (storeOpsData.status === "OP") {
                      setTillValue({});
                      history.push(`/login`);
                    } else {
                      setTillValue({});
                      setLoading(false);
                      Modal.confirm({
                        title: `This till has been closed "${dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")}"`,
                        icon: null,
                        cancelText: "",
                        okText: "Okay",
                        okButtonProps: { style: { display: "inline-block" } },
                        cancelButtonProps: { style: { display: "none" } }, // Disable the cancel button
                        onOk() {
                          getTillData();
                        },
                      });
                    }
                  }
                } catch (error) {
                  setTillValue({});
                  console.error("An error occurred:", error);
                  message.error(error);
                  setLoading(false);
                }
              };
              handleStoreOps();
            }
          } else {
            setTillValue({});
            setLoading(false);
            errorMessage("Login Failed", "User not configured for this Till", "user");
          }
        }
      } else {
        getTillData();
      }
    }
    };
    runAsync();
  }, [runEffect]);

  const getTillData = async () => {
    if (authHeaders && cleanToken && (username || email)) {
      setLoading(true);
      try {
        let userData = useAuthStore.getState().userData;
        // SSO bootstrap: if auth cookies exist but userData is missing, fetch it.
        // Also re-fetch when cached userData belongs to a different user than the
        // one currently authenticated via cookies (stale cache from a prior user
        // on this browser/device) — otherwise the wrong user_id gets sent to getTills().
        // NOTE: the User object's display-name field is "user", not "username".
        const identityMismatch = authHeaders?.username && userData?.user && userData.user !== authHeaders.username;
        if (!userData?.user_id || identityMismatch) {
          if (identityMismatch) {
            console.warn("[Till] Cached userData identity mismatch — re-fetching", { cached: userData?.user, current: authHeaders?.username });
          }
          try {
            const { getGlobalParameters } = await import("../../services/generic");
            const gpRes = await getGlobalParameters();
            if (gpRes?.status === 200) {
              const parsed = JSON.parse(gpRes.data.data.getGlobalParameters);
              useAuthStore.getState().setUserData(parsed.User);
              userData = parsed.User;
            }
          } catch (err) {
            console.error("[Till] SSO bootstrap failed:", err);
          }
        }
        const userid = userData?.user_id;
        if (!userid) {
          console.warn("[Till] getTillData: no user_id — session expired, redirecting to sign-in");
          window.location.href = "/sign-in";
          return;
        }
        const response = await getTills(userid);
        const tillsData = response?.data?.data?.getTills ?? [];
        if (tillsData.length === 0) {
          console.warn("[Till] getTillData: API returned 0 tills for user", userid);
          setTillLoadError("no_tills_found");
        } else {
          retryCountRef.current = 0;
          setTillLoadError(null);
        }
        const transformedData = tillsData.reduce((result, item) => {
          const { name } = item;
          const existingGroupIndex = result.findIndex((group) => group[name]);
          if (existingGroupIndex === -1) {
            result.push({ [name]: [item] });
          } else {
            result[existingGroupIndex][name].push(item);
          }
          return result;
        }, []);
        setTills(transformedData);
      } catch (error) {
        retryCountRef.current += 1;
        if (!error.response) {
          console.error("Network error: Unable to connect to the server", error);
          setTillLoadError("network");
        } else {
          console.error("Error while fetching till data:", error);
          setTillLoadError("api_error");
        }
      } finally {
        setLoading(false);
      }
    } else {
      console.warn("[Till] getTillData: missing auth credentials — cannot fetch tills");
      setTillLoadError("no_auth");
      setLoading(false);
    }
  };

  const callTillRegistration = async (cwrTillID, search_key) => {
    try {
      const syncId = uuidv4().replace(/-/g, "").toUpperCase();
      const timeMark = timeStamp();
      const resData = await tillRegistration(syncId, cwrTillID, search_key, timeMark, username);
      const tillData = resData?.data?.data?.tillRegistration;
      if (tillData?.status === "200" && tillData.tillAccess?.length > 0) {
        localStorage.setItem("syncId", syncId);
        const cwrTill0 = tillData.tillAccess[0].cwrTill || {};
        const serverSeq0 = cwrTill0.nextAssignedNumber || 0;
        const localMax0 = await getLocalMaxSequence(db, cwrTill0.prefix);
        const prevCounter0 = useSessionStore.getState().documentSequence;
        const chosenSeq0 = resolveInitialDocumentSequence(serverSeq0, localMax0);
        useSessionStore.getState().setDocumentSequence(chosenSeq0);
        logSequenceEvent(
          "init",
          { source: "till-registration", prefix: cwrTill0.prefix, serverSeq: serverSeq0, localMax: localMax0, chosen: chosenSeq0, prevCounter: prevCounter0 },
          db
        );

        const preSeq0 = cwrTill0.preorderSequence ? { ...cwrTill0.preorderSequence } : null;
        if (preSeq0) {
          const lpMax0 = await getLocalMaxSequence(db, preSeq0.prefix);
          preSeq0.nextNo = Math.max(preSeq0.nextNo || 0, lpMax0);
        }
        useSessionStore.getState().setPreorderSequence(preSeq0);

        const canSeq0 = cwrTill0.cancelledOrderSequence ? { ...cwrTill0.cancelledOrderSequence } : null;
        if (canSeq0) {
          const lcMax0 = await getLocalMaxSequence(db, canSeq0.prefix);
          canSeq0.nextNo = Math.max(canSeq0.nextNo || 0, lcMax0);
        }
        useSessionStore.getState().setCancelledOrderSequence(canSeq0);

        const seqPrefixes0 = [cwrTill0.prefix, preSeq0?.prefix, canSeq0?.prefix].filter(Boolean);
        if (new Set(seqPrefixes0).size !== seqPrefixes0.length) {
          console.error("[SEQ] Duplicate prefixes detected — falling back to single sequence mode");
          useSessionStore.getState().setPreorderSequence(null);
          useSessionStore.getState().setCancelledOrderSequence(null);
        }

        await db.tillRegistrations.add(tillData);
        const activityResponse = await upsertPOSActivity(tillData);
        if (activityResponse?.data?.data?.upsertPOSActivity?.status === "200") {
          setTillValue({});
          history.push(`/login`);
        }
      } else {
        setTillValue({});
        throw new Error(tillData?.message || "Till registration failed.");
      }
    } catch (error) {
      setTillValue({});
      console.error("An error occurred:", error);
      setLoading(false);
      Modal.error({
        title: error.message || "An unexpected error occurred.",
        onOk() {
          // Stay on till selection — just dismiss the modal
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const onRegistration = async (search_key, csbUnitId, csUserId, cwrTillID) => {
    const userData = useAuthStore.getState().userData;
    const userid = userData?.user_id;
    let posConfig = {};
    if (username || email) {
      try {
        setLoading(true);
        setRegistrationError(null);
        setLastRegistrationArgs({ search_key, csbUnitId, csUserId, cwrTillID });
        setRegistrationStep(0);
        const userData = Enterprise ? username : email;
        await syncTillData(userData, authHeaders);
        let tillData = useAuthStore.getState().tillData;
        useAuthStore.getState().setTillData(tillData);
        setRegistrationStep(1);
        const posConfigResponse = await posConfigService(cwrTillID);
        if (posConfigResponse?.data?.data?.getPOSConfig?.length > 0) {
          posConfig = posConfigResponse.data.data.getPOSConfig[0];
          const posConfigData = JSON.parse(posConfig?.configJson || "{}");
          const feedbackData = JSON.parse(posConfig?.feedback || "{}");
          const registrationTypes = JSON.parse(posConfig?.registrationTypes || "[]");
          useReferenceStore.getState().setRegistrationTypes(registrationTypes);
          usePOSConfigStore.getState().setPosConfig(posConfigData);
          usePOSConfigStore.getState().setPosType(posConfig.posType);
          localStorage.setItem("posConfigData", JSON.stringify(posConfig));
          useReferenceStore.getState().setFeedbackJson(feedbackData);
        } else {
          setLoading(false);
          errorMessage("Login Failed", "Error in getting POS configuration");
          return;
        }
        let matchedRep;
        if (tillData !== null && tillData !== undefined) {
          const tillAccessData = tillData.tillAccess;
          if (!tillAccessData || !Array.isArray(tillAccessData) || tillAccessData?.length === 0) {
            setLoading(false);
            errorMessage("Till Setup Error", "No till access data found. Please contact your administrator to configure till access for your account.");
            return;
          }
          const nameTill = useAuthStore.getState().tillValue?.name;
          const tillAccessIndex = (tillAccessData || [])?.findIndex((accessTill) => accessTill.cwrTill.till === nameTill);
          if (tillAccessIndex >= 0 || (tillAccessData && typeof tillAccessData === "object" && !Array.isArray(tillAccessData))) {
            // New object (not mutated in place). tillData here is the same reference
            // already sitting in the auth store (read at the top of this function) —
            // mutating tillAccess/time on it directly and passing it back into
            // setTillData() is a no-op from Zustand/React's point of view (same
            // reference in, same reference out), so any component subscribed via
            // useAuthStore((s) => s.tillData) — e.g. AppShell computing bunitId for
            // the WebSocket — never re-renders and never sees the resolved till.
            tillData = {
              ...tillData,
              // Persist the processed tillAccess (single object, not array) so CloseTill
              // can read tillData.tillAccess.csBunit without getting undefined.
              tillAccess: tillAccessIndex >= 0 ? tillAccessData[tillAccessIndex] : tillAccessData,
              time: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            };
            useAuthStore.getState().setTillData(tillData);
            trace("Till", "onRegistration: setTillData after tillAccess fix", {
              isArray: Array.isArray(tillData.tillAccess),
              hasCsBunit: !!tillData.tillAccess?.csBunit,
            });
            const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
            matchedRep = salesReps.find((rep) => rep.name === username);
          }
        }
        if (posConfig?.posType === "PRD") {
          setRegistrationStep(4);
          await callTillRegistration(cwrTillID, search_key);
        } else if (matchedRep) {
          setRegistrationStep(4);
          history.push("/login");
        } else {
          setRegistrationStep(2);
          const result = await handleStoreOpsService(csbUnitId);
          if (result?.redirected) return;
          if (result?.data?.data?.getStoreOps?.status === "ERR") {
            setLoading(false);
            const remarks = result?.data?.data?.getStoreOps?.remarks;
            const products = parseRemarksProducts(remarks);
            if (products.length > 0) {
              setErrorProducts(products);
              setErrorModalVisible(true);
            } else {
              message.error(remarks || `${messages.errors.system.unexpected_error}`);
            }
            return;
          } else if (result?.data?.data?.getStoreOps?.status === "WAR") {
            message.error(result?.data?.data?.getStoreOps?.remarks);
          }
          if (result?.data?.data?.getStoreOps === null) {
            const resStoreOps = await upsertStoreOps(csbUnitId, userid);
            if (resStoreOps?.data?.data?.upsertStoreOps?.status === "200") {
              setRegistrationStep(3);
              let syncId = uuidv4().replace(/-/g, "").toUpperCase();
              const timeMark = timeStamp();
              const resData = await tillRegistration(syncId, cwrTillID, search_key, timeMark, username);
              const tillData = resData.data.data.tillRegistration;
              localStorage.setItem("syncId", syncId);
              if (tillData?.status === "200") {
                await db.tillRegistrations.add(tillData);
                const cwrTill1 = tillData.tillAccess[0].cwrTill || {};
                const serverSeq1 = cwrTill1.nextAssignedNumber || 0;
                const localMax1 = await getLocalMaxSequence(db, cwrTill1.prefix);
                const prevCounter1 = useSessionStore.getState().documentSequence;
                const chosenSeq1 = resolveInitialDocumentSequence(serverSeq1, localMax1);
                useSessionStore.getState().setDocumentSequence(chosenSeq1);
                logSequenceEvent(
                  "init",
                  { source: "till-registration-storeops", prefix: cwrTill1.prefix, serverSeq: serverSeq1, localMax: localMax1, chosen: chosenSeq1, prevCounter: prevCounter1 },
                  db
                );

                const preSeq1 = cwrTill1.preorderSequence ? { ...cwrTill1.preorderSequence } : null;
                if (preSeq1) {
                  const lpMax1 = await getLocalMaxSequence(db, preSeq1.prefix);
                  preSeq1.nextNo = Math.max(preSeq1.nextNo || 0, lpMax1);
                }
                useSessionStore.getState().setPreorderSequence(preSeq1);

                const canSeq1 = cwrTill1.cancelledOrderSequence ? { ...cwrTill1.cancelledOrderSequence } : null;
                if (canSeq1) {
                  const lcMax1 = await getLocalMaxSequence(db, canSeq1.prefix);
                  canSeq1.nextNo = Math.max(canSeq1.nextNo || 0, lcMax1);
                }
                useSessionStore.getState().setCancelledOrderSequence(canSeq1);

                const seqPrefixes1 = [cwrTill1.prefix, preSeq1?.prefix, canSeq1?.prefix].filter(Boolean);
                if (new Set(seqPrefixes1).size !== seqPrefixes1.length) {
                  console.error("[SEQ] Duplicate prefixes detected — falling back to single sequence mode");
                  useSessionStore.getState().setPreorderSequence(null);
                  useSessionStore.getState().setCancelledOrderSequence(null);
                }

                setLoading(false);
                const response = await upsertPOSActivity(tillData);
                if (response?.data?.data?.upsertPOSActivity?.status === 200 || response?.data?.data?.upsertPOSActivity?.status === "200") {
                  setRegistrationStep(4);
                  history.push(`/login`);
                }
              } else {
                setLoading(false);
                errorMessage(tillData.message);
              }
            } else {
              message.error(resStoreOps?.data?.data?.upsertStoreOps?.message);
              setTillValue({});
              setTimeout(() => {
                for (let key in localStorage) {
                  if (key !== "userData") {
                    localStorage.removeItem(key);
                  }
                }
                window.location.assign("/till");
              }, 3000);
            }
          } else if (result?.data?.data?.getStoreOps?.status === "OP") {
            setRegistrationStep(3);
            await callTillRegistration(cwrTillID, search_key);
          } else {
            setLoading(false);
            Modal.confirm({
              title: `This till has been closed "${dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")}"`,
              icon: null,
              cancelText: "",
              okText: "Okay",
              okButtonProps: { style: { display: "inline-block" } },
              cancelButtonProps: { style: { display: "none" } }, // Disable the cancel button
              onOk() {
                Modal.destroyAll();
              },
            });
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setRegistrationError({ step: registrationStep, message: error.message || "An error occurred while fetching till data" });
        setLoading(false);
      }
    }
  };

  const onModalOkay = () => {
    setLoading(false);
    const keepKey = "userData"; // Replace with the key you want to keep
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key !== keepKey) {
        localStorage.removeItem(key);
      }
    }
  };

  const onUserModal = async () => {
    const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());
    const domainURL = process.env.REACT_APP_domain;
    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    const domainPart = isLocalhost ? "" : "domain=" + domainURL + ";";
    const securePart = isLocalhost ? "" : "secure=true;";
    for (let i = 0; i < cookiesToDelete.length; i++) {
      const cookie = cookiesToDelete[i];
      const eqPos = cookie.indexOf("=");
      const name = (eqPos > -1 ? cookie.substr(0, eqPos) : cookie).trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;${securePart}SameSite=Strict;${domainPart}`;
    }
    useSessionStore.getState().setTillSession(null);
    // lastUpdatedTime intentionally preserved — see useAuthStore.logout() comment.
    // An existing linked till should get an incremental sync on next login, not a full resync.
    // BUG-2026: await the shell's logout IPC before navigating — it's the
    // authoritative teardown; firing-and-forgetting it raced the redirect.
    await window.electronAPI?.auth?.logout();
    window.location.assign(`${redirectUrl}sign-in`);
  };

  const errorMessage = (modalTitle, modalContent, user) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
      onOk: user ? onUserModal : onModalOkay,
    });
  };

  const onTill = () => {
    if (cleanToken !== "bearer undefined" && (email || username)) {
      setRunEffect(true);
    } else {
      history.push("/sign-in");
    }
  };

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} className="spinLoader" spin />} spinning={loading}>
      {authHeaders ? (
        <Row className="till-select-row">
          <Col className="till-select-left-col" style={{ backgroundColor: "#F5FAFF" }} span={8}>
            <div className="till-select-left-panel" style={{ height: "100vh" }}>
              <Image className="till-select-logo" preview={false} src={logo} style={{ paddingTop: "4.5vh", paddingLeft: "2.6em", width: "93%" }} />
              <p className="till-select-welcome-text" style={{ fontFamily: "Inter", fontWeight: 600, fontSize: "1.8vw", paddingTop: "7vh", paddingLeft: "3em", color: "#0F0718" }}>
                Welcome to Point of Sale
                {multilingual && <span style={{ display: "block" }}>{t("Welcome to Point of Sale")}</span>}
              </p>
              <Image className="till-select-illustration" preview={false} src={laptop3} style={{ width: "30vw", marginLeft: "2em", height: "43vh" }} />
              <p className="till-select-footer-label" style={{ fontFamily: "Inter", fontWeight: 600, color: "#667085", fontSize: "13px", paddingTop: "7vh", paddingLeft: "3em" }}>Point of Sale </p>
              <p className="till-select-blurb" style={{ fontFamily: "Inter", fontWeight: 600, color: "#667085", fontSize: "0.9vw", paddingTop: "0.5em", paddingLeft: "3em", paddingRight: "5em" }}>
                {" "}
                Centralize the operations of your store, process transactions, manage inventory, follow orders, create reports of the store’s activities and much more!
              </p>
            </div>
          </Col>
          <Col className="till-select-right-col" span={16}>
            <div className="till-select-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "1.5rem 2rem" }}>
              <p
                className="till-select-title"
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 600,
                  fontSize: "1.25rem", // 20px
                  color: "#0F0718",
                  margin: 0,
                }}
              >
                {getMultilingualText("Select a Till to login")}
              </p>
              <div style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}>
                {/* Home button hidden on Till screen: history.push("/") reloads Till (re-triggers getTills)
                    instead of navigating to CW Browser Home, and Home is not supported in POS2.
                <div
                  onClick={() => history.push("/")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 500,
                      fontSize: "1rem",
                      color: "#0F0718",
                    }}
                  >
                    ← Home
                  </span>
                </div>
                */}
                <div
                  onClick={() => window.location.reload()}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <img src={SyncSide} alt="Refresh" style={{ height: "20px", width: "20px" }} />
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 500,
                      fontSize: "1rem",
                      color: "#0F0718",
                      marginLeft: "0.5rem",
                    }}
                  >
                    Refresh
                  </span>
                </div>
                <div
                  onClick={() => history.push({ pathname: "/health", state: { from: "/till" } })}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                  }}
                >
                  <MedicineBoxOutlined style={{ fontSize: "16px", color: "#1890ff" }} />
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 500,
                      fontSize: "1rem",
                      color: "#1890ff",
                      marginLeft: "0.5rem",
                    }}
                  >
                    Diagnostics
                  </span>
                </div>
              </div>
            </div>
            <Scrollbars style={{ height: "85vh" }}>
              {/* Error banner — visible even when tills are listed, so user knows something failed */}
              {tillLoadError && !loading && (tills?.length > 0 || tillValue?.search_key) && (
                <Alert
                  type={retryCountRef.current >= MAX_RETRIES ? "error" : "warning"}
                  showIcon
                  closable
                  style={{ margin: "0 2em 1em 2em" }}
                  message={
                    tillLoadError === "sync_failed"
                      ? "Till sync failed — your session data may be outdated"
                      : tillLoadError === "no_till_data"
                      ? "Could not load till configuration from server"
                      : tillLoadError === "no_till_access"
                      ? "Server returned no till access — your user may not be assigned to a till on the backend"
                      : tillLoadError === "network"
                      ? "Network connection failed"
                      : tillLoadError === "api_error"
                      ? "Server returned an error"
                      : "An issue was detected"
                  }
                  description={
                    <span>
                      {retryCountRef.current >= MAX_RETRIES
                        ? "Multiple attempts failed. This is likely a backend configuration issue, not a network problem. "
                        : "You can still select a till below, but it may not work until this is resolved. "}
                      <a
                        href="/health"
                        onClick={(e) => { e.preventDefault(); history.push({ pathname: "/health", state: { from: "/till" } }); }}
                        style={{ fontWeight: 600, cursor: "pointer" }}
                      >
                        <MedicineBoxOutlined /> Run Diagnostics
                      </a>
                    </span>
                  }
                />
              )}

              {/* Resume Setup — registration exists but initial sync never completed */}
              {resumeSetupVisible && !loading && (
                <Alert
                  type="info"
                  showIcon
                  icon={<SyncOutlined />}
                  style={{ margin: "0 2em 1em 2em" }}
                  message="Till registered but initial sync incomplete"
                  description={
                    <span>
                      This till was previously registered but the initial data sync did not complete. Products, pricing, and sale types are missing.{" "}
                      <Button
                        type="link"
                        style={{ padding: 0, fontWeight: 600 }}
                        onClick={() => {
                          setResumeSetupVisible(false);
                          history.push("/login");
                        }}
                      >
                        Resume Setup →
                      </Button>
                    </span>
                  }
                />
              )}

              {/* Registration Progress */}
              {registrationStep >= 0 && loading && (
                <div style={{ margin: "0 2em 1.5em 2em", padding: "16px 20px", background: "#fff", borderRadius: 8, border: "1px solid #e8e8e8" }}>
                  <Typography.Text strong style={{ fontSize: 14, marginBottom: 12, display: "block" }}>Setting up till...</Typography.Text>
                  <Steps
                    size="small"
                    current={registrationStep}
                    status={registrationError ? "error" : "process"}
                    items={REGISTRATION_STEPS.map((title, i) => ({
                      title,
                      icon: i < registrationStep ? <CheckCircleOutlined style={{ color: "#52c41a" }} /> :
                            i === registrationStep && registrationError ? <CloseCircleOutlined style={{ color: "#ff4d4f" }} /> :
                            i === registrationStep ? <LoadingOutlined spin /> : undefined,
                    }))}
                  />
                </div>
              )}

              {/* Registration Error + Retry */}
              {registrationError && !loading && (
                <Alert
                  type="error"
                  showIcon
                  style={{ margin: "0 2em 1em 2em" }}
                  message={`Registration failed at step: ${REGISTRATION_STEPS[registrationError.step] || "Unknown"}`}
                  description={
                    <span>
                      {registrationError.message}{" "}
                      {lastRegistrationArgs && (
                        <Button
                          type="link"
                          style={{ padding: 0, fontWeight: 600 }}
                          onClick={() => {
                            setRegistrationError(null);
                            setRegistrationStep(-1);
                            const { search_key, csbUnitId, csUserId, cwrTillID } = lastRegistrationArgs;
                            onRegistration(search_key, csbUnitId, csUserId, cwrTillID);
                          }}
                        >
                          Retry
                        </Button>
                      )}
                    </span>
                  }
                />
              )}

              {authHeaders?.access_token &&
                (authHeaders?.username || authHeaders?.email) &&
                tills?.map((e, index) => (
                  <div key={index} style={{ marginLeft: "2em", marginBottom: "1.5em" }}>
                    <p
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 600,
                        fontSize: "1vw",
                        paddingTop: "1.5em",
                        paddingLeft: "0.2em",
                        color: "#585768",
                        marginBottom: "0.5em",
                      }}
                    >
                      {Object.keys(e)[0]}
                    </p>

                    {/* 🔄 Responsive Flex Container */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "0.8rem",
                      }}
                    >
                      {e[Object.keys(e)[0]].map((res) => (
                        <Card
                          key={res.cwrTillID}
                          id="step1"
                          styles={{ body: { padding: "1vw", paddingBottom: 0 } }}
                          style={{
                            flex: "1 1 calc(20% - 1.5rem)",
                            minWidth: "10.5em",
                            maxWidth: "11em",
                            height: "8em",
                            borderRadius: "6px",
                            border: "1px solid #EEEEEF",
                            boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.04)",
                            backgroundColor: "#F3F4F9",
                            cursor: "pointer",
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                          }}
                          onClick={() => {
                            useAuthStore.getState().setTillValue({
                              search_key: res.searchKey,
                              cwr_till_id: res.cwrTillID,
                              name: res.till,
                              cSBunitID: res.cSBunitID,
                            });
                            onRegistration(res.searchKey, res.cSBunitID, res.cSUserId, res.cwrTillID);
                          }}
                        >
                          <div style={{ flexGrow: 1 }}>
                            <div>
                              <Image preview={false} src={posImg} style={{ height: "1.5vw" }} />
                              <span style={{ marginLeft: "1em", color: "#0F0718" }}>{res.till}</span>
                            </div>
                          </div>

                          <div style={{ position: "absolute", bottom: 0, left: "1vw" }}>
                            <Image preview={false} src={res.status === "AVL" ? green : res.status === "INU" ? red : green} style={{ height: "0.9vw" }} />
                            <span
                              style={{
                                marginLeft: "5px",
                                fontSize: "1vw",
                                fontWeight: 600,
                                color: "#0F0718",
                              }}
                            >
                              {res.status === "AVL" ? "Available" : res.status === "INU" ? "In Use" : "Not Registered"}
                            </span>
                            <p
                              style={{
                                fontFamily: "Inter",
                                fontWeight: 600,
                                color: "#667085",
                                fontSize: "0.9vw",
                                marginBottom: "7px",
                              }}
                            >
                              {/* {res.userName} */}
                            </p>
                          </div>
                        </Card>
                      ))}
                    </div>
                  </div>
                ))}

              {/* ✅ Active Till (Same Responsive Layout) */}
              {!tills && tillValue?.search_key && (
                <div style={{ marginLeft: "2em", marginBottom: "2em" }}>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.5rem",
                    }}
                  >
                    <Card
                      id="step1"
                      key={tillValue?.cwrTillID}
                      styles={{ body: { padding: "1vw" } }}
                      style={{
                        height: "7.5em",
                        width: "11em",
                        borderRadius: "6px",
                        border: "1px solid #EEEEEF",
                        boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.04)",
                        backgroundColor: "#F3F4F9",
                        cursor: "pointer",
                      }}
                      onClick={onTill}
                    >
                      <div>
                        <Image preview={false} src={posImg} style={{ height: "1.5vw" }} />
                        <span style={{ marginLeft: "1em", top: "15px" }}>{tillValue?.name}</span>
                      </div>
                      <div style={{ paddingTop: "1em" }}>
                        <span style={{ marginLeft: "5px", fontSize: "1vw", fontWeight: 600 }}></span>
                      </div>
                      <p
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 600,
                          marginLeft: "1.3em",
                          color: "#667085",
                          fontSize: "0.9vw",
                        }}
                      >
                        {tillValue?.userName}
                      </p>
                    </Card>
                  </div>
                </div>
              )}

              {!loading && !tills?.length && !tillValue?.search_key && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "60vh",
                    textAlign: "center",
                    padding: "2em",
                  }}
                >
                  <div
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "50%",
                      backgroundColor: "#FFF3E0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "1.5em",
                    }}
                  >
                    <span style={{ fontSize: "28px" }}>!</span>
                  </div>
                  <p
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 600,
                      fontSize: "1.2rem",
                      color: "#0F0718",
                      marginBottom: "0.5em",
                    }}
                  >
                    {tillLoadError === "network"
                      ? "Unable to Connect"
                      : tillLoadError === "no_user"
                      ? "User Session Expired"
                      : tillLoadError === "no_tills_found"
                      ? "No Tills Available"
                      : tillLoadError === "sync_failed"
                      ? "Sync Failed"
                      : tillLoadError === "no_auth"
                      ? "Authentication Required"
                      : "No Tills Found"}
                  </p>
                  <p
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      fontSize: "0.95rem",
                      color: "#667085",
                      maxWidth: "400px",
                      marginBottom: "1.5em",
                      lineHeight: 1.5,
                    }}
                  >
                    {tillLoadError === "network"
                      ? "Could not connect to the server. Please check your internet connection and try again."
                      : tillLoadError === "no_user"
                      ? "Your session could not be verified. Please log out and log in again."
                      : tillLoadError === "no_tills_found"
                      ? "No tills are configured for your account. Please contact your administrator to assign a CWR Till."
                      : tillLoadError === "sync_failed"
                      ? "Could not sync till data from the server. This may happen after a tenant switch or app update. Please try refreshing."
                      : tillLoadError === "no_till_access"
                      ? "The server returned null for till access (getTillAccess). This usually means your user is not assigned to a till on the backend, or the server's JDBC connection pool is exhausted. Contact your administrator."
                      : tillLoadError === "no_till_data"
                      ? "Till configuration returned empty from the server. The backend service may be down or misconfigured."
                      : tillLoadError === "no_auth"
                      ? "Authentication credentials are missing. Please log out and log in again."
                      : "No tills were found. Please try refreshing the page."}
                  </p>
                  {retryCountRef.current >= MAX_RETRIES && (
                    <p
                      style={{
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 500,
                        fontSize: "0.85rem",
                        color: "#ff4d4f",
                        maxWidth: "400px",
                        marginBottom: "1em",
                        lineHeight: 1.5,
                      }}
                    >
                      {retryCountRef.current} consecutive attempts have failed. This is likely a server-side issue — retrying will not help until the backend is fixed.
                    </p>
                  )}
                  <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", justifyContent: "center" }}>
                    <Button
                      type="primary"
                      onClick={() => {
                        setTillLoadError(null);
                        setTills(undefined);
                        getTillData();
                      }}
                      style={{
                        height: "40px",
                        borderRadius: "8px",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 500,
                      }}
                    >
                      Retry
                    </Button>
                    <Button
                      icon={<MedicineBoxOutlined />}
                      onClick={() => history.push({ pathname: "/health", state: { from: "/till" } })}
                      style={{
                        height: "40px",
                        borderRadius: "8px",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 500,
                      }}
                    >
                      Run Diagnostics
                    </Button>
                    {(tillLoadError === "no_user" || tillLoadError === "no_auth") && (
                      <Button
                        onClick={onUserModal}
                        style={{
                          height: "40px",
                          borderRadius: "8px",
                          fontFamily: "Inter, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Log Out
                      </Button>
                    )}
                  </div>
                </div>
              )}
            </Scrollbars>
          </Col>
          <Modal
            title="Stock Count Check Failed"
            open={errorModalVisible}
            onOk={() => setErrorModalVisible(false)}
            footer={[
              <Button key="ok" type="primary" onClick={() => setErrorModalVisible(false)}>
                OK
              </Button>,
            ]}
            onCancel={() => setErrorModalVisible(false)}
            centered
            width="70%"
          >
            <Table
              columns={[
                { title: "Item Name", dataIndex: "item_name", key: "item_name" },
                { title: "Item Code", dataIndex: "item_code", key: "item_code" },
              ]}
              dataSource={errorProducts}
              rowKey="item_code"
              pagination={false}
              size="small"
              scroll={{ x: "100%", y: "calc(100vh - 300px)" }}
            />
          </Modal>
        </Row>
      ) : (
        <Row></Row>
      )}
      <PostCloseSalesModal
        open={postCloseModalVisible}
        storeClosedDate={postCloseData.storeClosedDate}
        newBusinessDate={postCloseData.newBusinessDate}
        closedTime={postCloseData.closedTime}
        tillId={postCloseData.tillId}
        cashierName={postCloseData.cashierName}
        onContinue={handlePostCloseContinue}
        onCancel={handlePostCloseCancel}
      />
    </Spin>
  );
};
export default Till;
